/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.getTrendingTopics'

export { $nsid }

/** Get a list of trending topics */
const main = l.query(
  $nsid,
  l.params({
    viewer: l.optional(l.string({ format: 'did' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 25 }), 10),
    ),
  }),
  l.jsonPayload({
    topics: l.array(
      l.ref<UnspeccedDefs.TrendingTopic>(
        (() => UnspeccedDefs.trendingTopic) as any,
      ),
    ),
    suggested: l.array(
      l.ref<UnspeccedDefs.TrendingTopic>(
        (() => UnspeccedDefs.trendingTopic) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
